import PropTypes from "prop-types"

import FeatureGrid from "components/landing/feature-grid"
import { jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"

const occasionGridItems = [
  {
    background: "citrine",
    desktopImageId: "d_01_b8c06cec1b",
    mobileImageId: "m_01_bf9400fb8f",
    title: "Anniversary",
    url: "/anniversary-gifts",
  },
  {
    background: "pinkTourmaline",
    desktopImageId: "d_02_cae0242764",
    mobileImageId: "m_02_a7ca8cf0ed",
    title: "Birthday",
    url: "/birthday-gifts",
  },
  {
    background: "peridot",
    desktopImageId: "d_peridot_edit_336d09bec3",
    mobileImageId: "m_peridot_edit_e7c4d5ea89",
    title: "Peridot Edit",
    url: `/peridot-${jewlr_t("terms.jewelry")}`,
  },
  {
    background: "aquamarine",
    desktopImageId: "d_04_97db05a563",
    mobileImageId: "m_04_cf17ec7dcc",
    title: "Wedding",
    url: `/wedding-${jewlr_t("terms.jewelry")}`,
  },
]

const createOccasionGridItem = (itemData) => ({
  cta: "Shop Now",
  image: {
    fallback: `https://cms.jewlr.com/${itemData.desktopImageId}/${itemData.desktopImageId}.jpg`,
    srcSet: [
      {
        height: 334,
        media: "(max-width: 767px)",
        sizes: "50vw",
        srcSet: getImgSrcSet(
          `${sl.config.jewlr_imgsmbly_url}cms/${itemData.mobileImageId}/${itemData.mobileImageId}.jpg`,
          334
        ),
        width: 334,
      },
      {
        height: 872,
        media: "(min-width: 768px)",
        sizes: "(min-width: 1920px) 420px, 25vw",
        srcSet: getImgSrcSet(
          `${sl.config.jewlr_imgsmbly_url}cms/${itemData.desktopImageId}/${itemData.desktopImageId}.jpg`,
          840
        ),
        width: 840,
      },
    ],
  },
  style: {
    block_style: {
      display: "flex",
      flexDirection: "column-reverse",
    },
    container_style: {
      bg: itemData.background,
      color: "blackPrint",
      flex: "1",
      justifyContent: "space-between",
      position: "static",
      px: { _: 1, desktop: 2 },
      py: { _: 1, desktop: "20px" },
    },
    cta_style: {
      fontSize: { _: "10px", desktop: "16px" },
      fontWeight: "600",
      lineHeight: "100%",
      textTransform: "uppercase",
    },
    title_style: {
      fontSize: { _: "15px", tablet: "20px", widescreen: "22px" },
      fontWeight: "700",
      lineHeight: "100%",
      mb: { _: "4px", desktop: 1 },
      textTransform: "none",
    },
  },
  title: itemData.title,
  url: itemData.url,
})

const occasionGridElementData = {
  items: occasionGridItems.map(createOccasionGridItem),
}

const OccasionGrid = ({
  element = { style: { block_style: {} } },
  lazyload,
}) => {
  element.contain = true
  element.data = occasionGridElementData
  element.container_style = {
    py: 0,
    ...element.container_style,
  }
  element.style = {
    ...element.style,
    block_style: {
      py: 3,
      ...element.style.block_style,
    },
  }

  return <FeatureGrid element={element} lazyload={lazyload} />
}

OccasionGrid.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default OccasionGrid
